// extracted by mini-css-extract-plugin
export var arbiterBadgeContainer = "_t-0";
export var colorSwatch = "_t-5";
export var compactSwatch = "_t-7";
export var fillWidth = "_t-4";
export var iconButton = "_t-2";
export var iconWrapper = "_t-3";
export var shadow = "_t-6";
export var xs = "_t-1";